<template>
  <div class="page">
    <div class="head-warp">
      <div class="title">诚信合作，创新共享</div>
      <div class="description">赢科天地，致力于中国教育行业信息化建设十余年，不断创新，成为引领高等院校信息化建设的高科技企业。我们已经。</div>
    </div>
    <div class="job">
      <div>
        <div class="title">岗位名称</div>
        <div class="value">{{job.remark01}}</div>
      </div>
      <div>
        <div class="title">招聘人数</div>
        <div class="value">{{job.remark02}}</div>
      </div>
      <div>
        <div class="title">学历要求</div>
        <div class="value">{{job.remark04}}</div>
      </div>
      <div>
        <div class="title">工作地点</div>
        <div class="value">{{job.remark03}}</div>
      </div>
    </div>
    <div class="content" v-html="job.content"></div>
  </div>
</template>

<script>
export default {
  name: 'Jobs',
  data() {
    return {
      job: {
        remark01: 'Java开发工程师',
        remark02: '2人',
        remark03: '北京、哈尔滨',
        remark04: '本科及以上',
        content: '<p><b>岗位职责：</b></p><p>1. 负责公司教育信息化软件产品的后端设计与开发；</p><p>2. 参与系统架构设计与技术选型，保障系统的稳定性与扩展性；</p><p>3. 与产品、前端团队协作，按时高质量交付迭代版本。</p><p><b>任职要求：</b></p><p>1. 计算机相关专业本科及以上学历；</p><p>2. 熟悉Java及相关框架，有大型项目经验者优先；</p><p>3. 具备良好的沟通能力与团队协作精神。</p>',
      },
      content: '',
    }
  },
  methods: {
    /**
     * 根据参数名 获取 URL 路径中的参数
     * @param {String} name 要读取的参数名称
     */
    // getUrlParam(name) {
    //   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    //   let search = window.location.href.split('?')[1]
    //   if (search) {
    //     var r = search.substr(0).match(reg)
    //     if (r !== null) return unescape(r[2])
    //     return null
    //   } else {
    //     return null
    //   }
    // },
  },
  mounted() {
    let parentid = this.$route.query.id
    let url =
      this.HOST + 'wzContent/info?moduleOrder=ordernum&contentOrder=ordernum&websiteid=4&id='
    url = this.$getUrl(url, parentid)
    this.$axios.get(url).then((res) => {
      this.job = res.data.content
    })
  },
}
</script>

<style scoped lang="less">
.page {
  .head-warp {
    padding: 20px 80px;
    text-align: left;
    background-image: url('../assets/zpqs.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      font-size: 26px;
      font-weight: 600;
    }
    .description {
      width: 550px;
      font-size: 16px;
    }
  }
  .job {
    display: flex;
    width: 1000px;
    margin: 60px auto;
    border-bottom: 1px solid #ddd;
    & > div {
      flex: 1;
      margin: 0 30px 20px 0;
      text-align: left;
      border-right: 1px solid #ddd;
      .title {
        font-size: 14px;
      }
      .value {
        font-size: 17px;
        font-weight: 500;
      }
    }
    & > div:last-child {
      margin-right: 0;
      border-right: 0 solid #fff;
    }
  }
  .content {
    width: 1000px;
    padding-bottom: 50px;
    margin: 0 auto;
    text-align: left;
  }
}
</style>
